import { Component } from '@angular/core';

@Component({
  selector: 'wl-google-play-logo',
  standalone: true,
  templateUrl: './google-play-logo.component.html',
})
export class GooglePlayLogoComponent {}
